import { AccessIs } from 'helper/access-permission'

export type HeaderNavegationItem = {
  title: string;
  route: string;
  disable: boolean;
  visible: boolean;
  access: string[];
};

export type HeaderNavegation = {
  navTitle: string;
  idNav: string;
  visible: boolean;
  navItem: HeaderNavegationItem[];
};

export const HeaderNavegationList: HeaderNavegation[] = [
  {
    navTitle: 'Análise',
    idNav: 'nav-dropdown-analysis',
    visible: false,
    navItem: [
      {
        title: 'Carga',
        route: '/file-load',
        disable: true,
        visible: false,
        access: [AccessIs.carga],
      },
      {
        title: 'Analítico',
        route: '/analitico',
        disable: true,
        visible: false,
        access: [AccessIs.analitico],
      },
      {
        title: 'Sintético',
        route: '/sintetico',
        disable: true,
        visible: false,
        access: [AccessIs.sintetico],
      },
      {
        title: 'Gerencial',
        route: '/gerencial',
        disable: true,
        visible: false,
        access: [AccessIs.gerencial],
      },
      {
        title: 'Equalização',
        route: '/equalizacao',
        disable: true,
        visible: false,
        access: [AccessIs.equalizacao],
      },
      {
        title: 'Indicador',
        route: '/indicador',
        disable: true,
        visible: false,
        access: [AccessIs.indicador],
      },
      {
        title: 'Pesquisar Item na Rede',
        route: '/consulta-item-rede',
        disable: true,
        visible: false,
        access: [AccessIs.consultaItemRede],
      },
      {
        title: 'Campanhas Ativas',
        route: '/campanhas-ativas',
        disable: true,
        visible: false,
        access: [AccessIs.campanhasAtivas],
      },
      {
        title: 'Pedidos',
        route: '/pedidos',
        disable: true,
        visible: false,
        access: [AccessIs.pedidos],
      },
      {
        // As roles devem ser as MESMAS de '/pedidos' logo acima: os dois itens são as duas faces
        // do mesmo gate (itemMenuVisivelPorFluxo) e a empresa vê exatamente um deles. Divergir
        // aqui faz o perfil sumir dos DOIS quando a flag do fluxo novo está ligada.
        title: 'Aprovação de Pedidos',
        route: '/fluxo-aprovacao-pedido',
        disable: true,
        visible: false,
        access: [AccessIs.pedidos],
      },
    ],
  },
  {
    navTitle: 'Fornecedor',
    idNav: 'nav-dropdown-provider',
    visible: false,
    navItem: [
      {
        title: 'Cadastro de Itens Originais',
        route: '/itens-originais',
        disable: true,
        visible: false,
        access: [AccessIs.itensOriginais],
      },
      {
        title: 'Cadastrar Status de Item Original',
        route: '/itens-originais-status',
        disable: true,
        visible: false,
        access: [AccessIs.itensOriginaisStatus],
      },
      {
        title: 'Cadastrar Item Correlato',
        route: '/itens-correlato',
        disable: true,
        visible: false,
        access: [AccessIs.itensCorrelato],
      },
      {
        title: 'Cadastrar Filial Fornecedor',
        route: '/filial-fornecedor',
        disable: true,
        visible: false,
        access: [AccessIs.filialFornecedor],
      },
      {
        title: 'Cadastrar Setor',
        route: '/setor',
        disable: true,
        visible: false,
        access: [AccessIs.setor],
      },
      {
        title: 'Cadastrar Regional',
        route: '/regional',
        disable: true,
        visible: false,
        access: [AccessIs.regional],
      },
      {
        title: 'Carregar Arquivos Fornecedor',
        route: '/carregar-arquivos-fornecedor',
        disable: true,
        visible: false,
        access: [AccessIs.carregarArquivosFornecedor],
      },
    ],
  },
  {
    navTitle: 'Segurança',
    idNav: 'nav-dropdown-security',
    visible: false,
    navItem: [
      {
        title: 'Cadastrar Grupo da Empresa',
        route: '/grupo-empresa',
        disable: true,
        visible: false,
        access: [AccessIs.grupoEmpresa],
      },
    ],
  },
  {
    navTitle: 'Scrap',
    idNav: 'nav-dropdown-scrap',
    visible: false,
    navItem: [
      {
        title: 'Cadastro Filtro Scrap',
        route: '/filtro-scrap',
        disable: true,
        visible: false,
        access: [AccessIs.filtroScrap],
      },
      {
        title: 'Aprovação Scrap',
        route: '/aprovacao-scrap',
        disable: true,
        visible: false,
        access: [AccessIs.aprovacaoScrap],
      },
      {
        title: 'Consulta de Scrap',
        route: '/consulta-scrap',
        disable: true,
        visible: false,
        access: [AccessIs.consultaScrap],
      },
      {
        title: 'Gerar Scrap',
        route: '/gerar-scrap',
        disable: true,
        visible: false,
        access: [AccessIs.gerarScrap],
      },
      {
        title: 'Relatório Scrap',
        route: '/relatorio-scrap',
        disable: true,
        visible: false,
        access: [AccessIs.relatorioScrap],
      },
    ],
  },
  {
    navTitle: 'Configurações',
    idNav: 'nav-dropdown-configuration',
    visible: false,
    navItem: [
      {
        title: 'Cadastrar Valor da Curva',
        route: '/valor-curva',
        disable: true,
        visible: false,
        access: [AccessIs.valorCurva],
      },
      {
        title: 'Cadastrar Pontuação Curva',
        route: '/pontuacao-curva',
        disable: true,
        visible: false,
        access: [AccessIs.pontuacaoCurva],
      },
      {
        title: 'Cadastrar Giro da Curva Empresa',
        route: '/giro-curva-empresa',
        disable: true,
        visible: false,
        access: [AccessIs.giroCurvaEmpresa],
      },
      {
        title: 'Giro da Curva',
        route: '/giro-curva-usuario',
        disable: true,
        visible: false,
        access: [AccessIs.giroCurvaUsuario],
      },
      {
        title: 'Consultar Log Carga',
        route: '/log-carga',
        disable: true,
        visible: false,
        access: [AccessIs.logCarga],
      },
      {
        title: 'Cadastrar Mensagem',
        route: '/mensagem',
        disable: true,
        visible: false,
        access: [AccessIs.mensagem],
      },
      {
        title: 'Cadastrar Comunicado',
        route: '/comunicacao',
        disable: true,
        visible: false,
        access: [AccessIs.comunicado],
      },
      {
        title: 'Cadastrar Observação em Item',
        route: '/observacao-item',
        disable: true,
        visible: false,
        access: [AccessIs.observacaoItem],
      },
      {
        title: 'Cadastrar Feriado',
        route: '/feriado',
        disable: true,
        visible: false,
        access: [AccessIs.feriado],
      },
      {
        title: 'Cadastrar Configuração',
        route: '/cadastrar/configuracao',
        disable: true,
        visible: false,
        access: [AccessIs.configuracao],
      },
      {
        title: 'Cadastrar Fabricante',
        route: '/fabricante',
        disable: true,
        visible: false,
        access: [AccessIs.fabricante],
      },
      {
        title: 'Cadastrar Fornecedor',
        route: '/cadastrar/fornecedor',
        disable: true,
        visible: false,
        access: [AccessIs.fornecedor],
      },
      {
        title: 'Cadastrar Regras de Consultor Online',
        route: '/config-consultor-online-v2',
        disable: true,
        visible: false,
        access: [AccessIs.consultorOnline],
      },
      {
        title: 'Cadastro de Ordenação',
        route: '/ordenacao',
        disable: true,
        visible: true,
        access: [AccessIs.ordenacao],
      },
      {
        title: 'Cadastrar Usuário',
        route: '/usuario',
        disable: true,
        visible: false,
        access: [AccessIs.usuario],
      },
      {
        title: 'Tutorial de Telas',
        route: '/tutorial',
        disable: true,
        visible: true,
        access: [AccessIs.tutorial],
      },
    ],
  },
];
